<template>
  <v-container>
    <v-card class="mt-2">
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="items"
        :sort-by="'code'"
        hideDefaultFooter
        disablePagination
      >
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
import LookupValueInput from "common/components/LookupValueInput.vue";
import { defineComponent } from "vue";
export default defineComponent({
  name: "Subjects",
  components: { LookupValueInput },
  props: ["search"],
  data() {
    return {
      loading: false,
      categories: [],
      selectedCategory: null,
      type: null,

      headers: [
        { text: "id", value: "id" },
        { text: "code", value: "code" },
        { text: "description", value: "description" },
      ],
      items: [],
    };
  },

  async created() {
    this.loading = true;
    this.items = await this.apiList({ resource: "common/department" });
    this.loading = false;
  },
});
</script>
